import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './account-auth-layout.module.css';
import { isAuthNavigationTarget } from '../../../../utils/auth-form-navigation';

interface AccountAuthLayoutProps {
    children: React.ReactNode;
    alternatives?: React.ReactNode;
    footer?: React.ReactNode;
    intent?: 'login' | 'signUp';
}

export const AccountAuthLayout: React.FC<AccountAuthLayoutProps> = ({
    children,
    alternatives,
    footer,
    intent = 'login',
}) => {
    const { t } = useTranslation();

    return (
        <div
            className={styles.layout}
            onMouseDownCapture={(event) => {
                if (event.button === 0 && isAuthNavigationTarget(event.target)) event.preventDefault();
            }}
        >
            <div className={styles.primary}>{children}</div>
            {alternatives && (
                <>
                    <div className={styles.separator}>
                        <span>
                            {t(`dialogs.common.${intent === 'signUp' ? 'otherSignUpOptions' : 'otherLoginOptions'}`)}
                        </span>
                    </div>
                    <div className={styles.alternatives}>{alternatives}</div>
                </>
            )}
            {footer && <div className={styles.footer}>{footer}</div>}
        </div>
    );
};
